import React from "react";
import BoostIcon from "./BoostIcon";

export default function BoostHelpModal({ boost = null, ownedCount = 0, onClose }) {
    if (!boost) {
        return null;
    }

    return (
        <div
            className="guideHeartDemoOverlay boostHelpModal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="boostHelpModalTitle"
            onClick={typeof onClose === "function" ? onClose : undefined}
        >
            <div
                className="guideHeartDemoOverlay__panel boostHelpModal__panel"
                onClick={(event) => event.stopPropagation()}
            >
                <button
                    type="button"
                    className="boostHelpModal__close"
                    aria-label="Close boost details"
                    onClick={onClose}
                >
                    ×
                </button>

                <div className="boostHelpModal__iconWrap" aria-hidden="true">
                    <BoostIcon boost={boost} size={56} />
                </div>

                <h2 id="boostHelpModalTitle" className="guideHeartDemoOverlay__title">
                    {boost.name}
                </h2>

                <p className="guideHeartDemoOverlay__message boostHelpModal__description">
                    {boost.description}
                </p>

                <p className="boostHelpModal__meta">
                    In inventory:{" "}
                    <strong>{Number(ownedCount).toLocaleString("en-US")}</strong>
                </p>

                <p className="boostHelpModal__hint">
                    Spend boosts from Inventory during Story and Endless runs. They
                    are unavailable in Hardcore and Blitz modes.
                </p>

                <div className="noticePrompt__actions">
                    <button
                        type="button"
                        className="homePrimaryButton guideHeartDemoOverlay__button"
                        onClick={onClose}
                    >
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}
